import React from 'react';
import './Newsletter.css';

const NewsletterSection = () => {
  return (
    <section className="newsletter-section">
  <div className="container">
    <h2 className="newsletter-title">Ready to Dive into the Quantum World?</h2>
    <p className="newsletter-description">
      Join our newsletter and be the first to know about the latest quantum technologies advancements, events, and community highlights.
    </p>

    <div className="beehiiv-slim-wrapper">
      <iframe
        title="Newsletter Subscription"
        src="https://embeds.beehiiv.com/6000e864-f617-4011-b9a3-84cb75f7ad05?slim=true"
        data-test-id="beehiiv-embed"
        height="52"
        frameBorder="0"
        scrolling="no"
        style={{
          margin: 0,
          backgroundColor: "transparent",
        }}
      ></iframe>
    </div>

    <a
      href="https://quantumke.beehiiv.com/"
      className="newsletter-browse-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      Browse past newsletters &rarr;
    </a>
  </div>
</section>
  );
};

export default NewsletterSection;
